'use es6';

import dispatcher from 'dispatcher/dispatcher';
import { defineAuthStore } from '../store/AuthStore';
export default defineAuthStore({
  getter: (state, field) => field ? state[field] : state,
  initialState: {},
  name: 'UserStore',
  onAuthLoad: auth => auth.user
}).register(dispatcher);